import { Component, EventEmitter, Output } from '@angular/core';

/**
 * @description Component
 * @class ModalComponent
 */
@Component({
  standalone: false,
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})

export class ModalComponent {
  @Output() clickedClose = new EventEmitter();  
  /**
   * @description Creates an instance of ModalComponent.
   */
  constructor(
  ) { }
}
